import styles from './renttimer.module.sass';
import cn from 'classnames';
import { FontIcon } from '../FontIcon';

interface RentTimerProps extends React.HTMLAttributes<HTMLDivElement> {
    timeCount: [number, 'hour' | 'minute'];
    /** 100% of the countdown */
    base?: number;
    /** label for the hour/minute value */
    timeType: string;
    labelRemaining: string;
    /** inline variant only */
    labelBefore?: string;
    expired?: boolean;
    expiredLabel?: string;
    almostEnded?: boolean;
    inline?: boolean;
    reverse?: boolean;
    isSmall?: boolean;
}

function numberToPercent(num: number, base: number): number {
    if (base === 0) throw new Error('Base value cannot be zero.');
    return parseFloat(((num / base) * 100).toFixed(1));
}

export const RentTimer = ({
    timeCount,
    timeType,
    labelRemaining,
    labelBefore,
    expired,
    expiredLabel,
    almostEnded,
    inline,
    base,
    reverse,
    isSmall,
    className,
    ...props
}: RentTimerProps) => {
    const classes = cn(
        styles.timer,
        expired && styles.expired,
        almostEnded && styles.almost,
        inline && styles.inline,
        inline && labelBefore && styles.holder,
        reverse && styles.reverse,
        isSmall && styles.small,
        className
    );

    // const percent = numberToPercent(timeCount[0], timeCount[1] === 'hour' ? 48 : 60);
    const defaultBase = timeCount[1] === 'hour' ? 48 : 60;
    const percent = numberToPercent(timeCount[0], base || defaultBase);

    return (
        <div className={classes} {...props}>
            {inline && labelBefore && <span className={styles.label}>{labelBefore}</span>}
            <div className={styles.frame}>
                <svg viewBox="0 0 36 36" className={styles.progress}>
                    <path
                        className={styles['circle-bg']}
                        d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                    <path
                        className={styles.circle}
                        strokeDasharray={
                            reverse
                                ? expired
                                    ? '0, 100'
                                    : `${100 - percent}, 100` // start with empty and then fill with color
                                : expired
                                ? '100, 100'
                                : `${percent}, 100` // start with full and then transparent
                        }
                        d="M18 2.0845
                                    a 15.9155 15.9155 0 0 1 0 31.831
                                    a 15.9155 15.9155 0 0 1 0 -31.831"
                    />
                </svg>
                {expired && labelBefore && (
                    <span className={styles.mark}>
                        <FontIcon name="alert" size="medium" md="medium" color="red" />
                    </span>
                )}
            </div>
            <div className={styles.count}>
                {expired &&
                    (labelBefore ? (
                        <strong>
                            <span>{timeCount[0]}</span>
                            {timeType}
                        </strong>
                    ) : (
                        <strong>{expiredLabel}</strong>
                    ))}
                {!expired && (
                    <>
                        <strong>
                            <span>{timeCount[0]}</span>
                            {timeType}
                        </strong>
                        <i>{labelRemaining}</i>
                    </>
                )}
            </div>
        </div>
    );
};
